import { IDP_HINT_PARAM } from "./idpHint";

// Pure URL helper shared by both apps (SONeuWebApp + SONeuExternalApp) so the OIDC deep-link handling
// stays identical.

// Query params Keycloak appends to the redirect target after login; meaningless once the auth code has
// been exchanged for tokens.
export const OIDC_CALLBACK_PARAMS = ["code", "state", "session_state", "iss"];

// Everything the auth plumbing leaves in the URL and that must not survive into app state: Keycloak's
// callback params on the way back, plus the entry marker the FSW start link carries in.
export const TRANSIENT_AUTH_PARAMS = [...OIDC_CALLBACK_PARAMS, IDP_HINT_PARAM];

// The current page with the spent auth params removed. Used both as the post-login redirect target (so
// a deep link survives the Keycloak round-trip) and to scrub the address bar afterwards. Stripping the
// params also keeps the error-retry path from re-submitting an already-consumed auth code. Removal is
// by param name, so an unrecognized marker value is cleaned out too.
export function sanitizedCurrentUrl(): string {
  const url = new URL(window.location.href);
  TRANSIENT_AUTH_PARAMS.forEach((param) => url.searchParams.delete(param));
  return url.toString();
}
